import { render } from "./ImportProducts.vue?vue&type=template&id=c5958e50&scoped=true&ts=true"
import script from "./ImportProducts.vue?vue&type=script&lang=ts"
export * from "./ImportProducts.vue?vue&type=script&lang=ts"

import "./ImportProducts.vue?vue&type=style&index=0&id=c5958e50&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5958e50"]])

export default __exports__